// import handleSnackbar from '~/mixins/handleSnackbar'
import renderUrl from '~/util/renderUrl'
export default {
    props: {
        page: {
            type: Object,
            default: null,
        },
        content: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            postsByTopic: {},
            topicPosts: [],
            allPosts: [],
        }
    },
    methods: {
        renderUrl({ item, lang, nuxt }) {
            return renderUrl({ item, lang, nuxt })
        },
        sortItems(items, sortBy, limit = 999) {
            if (sortBy === 'publishDate') {
                items.sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1))
            } else if (sortBy === 'sequence') {
                items.sort((a, b) =>
                    parseInt(a.sequence) > parseInt(b.sequence) ? 1 : -1
                )
            } else if (sortBy === 'title') {
                items.sort((a, b) => (a.title > b.title ? 1 : -1))
            }
            return items.filter((item, i) => {
                return parseInt(i) < limit
            })
        },
        sortByTopic(topics, posts) {
            this.sortItems(topics, 'sequence').forEach((element) => {
                this.postsByTopic[element.slug[this.$i18n.locale].current] = []
            })
            this.postsByTopic['misc'] = []
            posts.forEach((post) => {
                if (post.topics) {
                    Object.keys(this.postsByTopic).forEach((item) => {
                        if (post.topics.find((p) => p.slug[this.$i18n.locale].current === item))
                            this.postsByTopic[item].push(post)
                    })
                } else this.postsByTopic['misc'].push(post)
            })
            for (const property in this.postsByTopic) {
                this.postsByTopic[property] = this.sortItems(
                    this.postsByTopic[property],
                    'title'
                )
            }
        },
        getTopicPosts() {
            const slug = this.$route.params.slug
            this.topicPosts = this.postsByTopic[slug]
        },
        getAllPosts() {
            let temp1 = []
            Object.values(this.postsByTopic).forEach(
                (value) =>
                    (temp1 = [...temp1, ...this.sortItems(value, 'sequence')])
            )
            const filteredArr = temp1.reduce((acc, current) => {
                const x = acc.find(
                    (item) => item.slug.en.current === current.slug.en.current
                )
                if (!x) {
                    return acc.concat([current])
                } else {
                    return acc
                }
            }, [])
            this.allPosts = filteredArr
        },
        setCrop() {
            if (this.page.whitepapers) {
                return 'fit'
            }
            if (this.page.blog) {
                return 'fill'
            }
            return 'fill'
        },
        fallbackImageId(thumb) {
            return thumb && thumb.imageId ? thumb.imageId : 'c3controls-icon'
        },
        fallbackImageDir(thumb) {
            return thumb && thumb.imageDir ? thumb.imageDir : 'logos'
        },
        fallbackImageAlt(thumb) {
            return thumb && thumb.alt
                ? thumb.alt
                : { en: 'c3controls', es: 'c3controls' }
        },
    },
    computed: {
        itemsSorted() {
            return this.sortItems(
                this.posts,
                'publishDate',
                this.postsLimit
            ).filter((item, key) => {
                return key < this.postsLimit
            })
        },
        postsLimit() {
            return this.content && this.content.limit ? this.content.limit : 99
        },
        featuredPosts() {
            return this.page &&
                this.page.featuredPosts &&
                this.page.featuredPosts.length > 0
                ? this.sortItems(
                    this.page.featuredPosts,
                    'publishDate',
                    this.postsLimit
                )
                : []
        },
        featuredCategories() {
            return this.page &&
                this.page.featured &&
                this.page.featured.length > 0
                ? this.sortItems(
                    this.page.featured,
                    'sequence',
                    this.postsLimit
                )
                : []
        },
        featuredSubcategories() {
            return this.page &&
                this.page.subcategories &&
                this.page.subcategories.length > 0
                ? this.sortItems(
                    this.page.subcategories,
                    'sequence',
                    this.postsLimit
                )
                : []
        },
        featuredProfiles() {
            return this.page &&
                this.page.featuredProfiles &&
                this.page.featuredProfiles.length > 0
                ? this.page.featuredProfiles
                : []
        },
        featuredTestimonials() {
            return this.page &&
                this.page.featuredTestimonials &&
                this.page.featuredTestimonials.length > 0
                ? this.page.featuredTestimonials
                : []
        },
        posts() {
            if (this.page) {
                if (this.page._type === 'topic') {
                    return this.topicPosts
                }
                if (
                    (this.page.whitepapers &&
                        this.page.whitepapers.length > 0) ||
                    (this.page.blog && this.page.blog.length > 0)
                ) {
                    return this.allPosts
                } else if (
                    this.page.featuredPosts &&
                    this.page.featuredPosts.length > 0
                ) {
                    return this.page.featuredPosts
                } else if (
                    this.page.featured &&
                    this.page.featured.length > 0
                ) {
                    return this.page.featured
                } else if (
                    this.page.subcategories &&
                    this.page.subcategories.length > 0
                ) {
                    return this.page.subcategories
                }
            }
            return []
        },
        showSidebar() {
            return true
            // return this.page._type === 'topic' ? false : true
        },
    },
    mounted() {
        if (this.page) {
            if (this.page.whitepapers && this.page.whitepapers.length > 0) {
                this.sortByTopic(this.page.topic, this.page.whitepapers)
            } else if (this.page.blog && this.page.blog.length > 0) {
                this.sortByTopic(this.page.topic, this.page.blog)
            }
            this.getTopicPosts()
            this.getAllPosts()
        }
    },
}
